<template>
  <div class="category-node">
    <el-button type="text" class="all w-full" :class="{'category-active':value===0}" v-if="allText"
               @click="handleClick({id:0})">
      {{ allText }}
    </el-button>
    <el-tree
        class="category-tree"
        :data="treeData"
        ref="tree"
        draggable
        highlight-current
        @node-click="handleClick"
        node-key="id"
        @node-drop="handleDrop"
        @node-drag-end="handleDrop"
        default-expand-all
        :expand-on-click-node="false">
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <div>{{ node.label }}</div>
        <div v-if="isAction">
          <el-button type="text" icon="el-icon-ali-move"></el-button>
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(data)"></el-button>
          <el-button type="text" icon="el-icon-delete" @click="handleDelete(data)"></el-button>
        </div>
      </div>
    </el-tree>
  </div>
</template>
<script>
export default {
  name: "login",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {},
  /**
   * 组建属性
   * @type {Object}
   */
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    treeData: {
      type: Array,
    },
    isAction: {
      type: Boolean,
      default: false
    },
    allText: {
      type: String,
      default: ''
    }
  },
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {};
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {

  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {
    handleEdit(data) {
      this.$emit("edit", data, "edit")
    },
    handleDrop(draggingNode, dropNode, dropType) {
      console.log('dropType', dropType, draggingNode.data.name, dropNode.data.name, draggingNode.data, dropNode.data)
      // 移入
      if (dropType === 'inner') {
        let data = {
          parentId: dropNode.data.id,
          id: draggingNode.data.id,
          move: {
            id: dropNode.data.id,// 对比的节点Id
            type: dropType
          }
        }
        // console.log('data',data)
        // 排序添加到最后
        this.$emit("edit", data)
      } else {
        // 移动层级
        if (dropNode.data.parentId !== draggingNode.data.parentId) {
          let data = {
            parentId: dropNode.data.parentId,
            id: draggingNode.data.id,// 移动的节点Id
            move: {
              id: dropNode.data.id,// 对比的节点Id
              type: dropType// 前后
            }
          }
          //console.log('data',data)
          this.$emit("edit", data)
        } else {
          // 同级移动排序
          let data = {
            parentId: dropNode.data.parentId,
            id: draggingNode.data.id,// 移动的节点Id
            move: {
              id: dropNode.data.id,// 对比的节点Id
              type: dropType// 前后
            }
          }
          //console.log('data',data)
          this.$emit("edit", data)
        }
      }
      // if (dropNode.data.parentId !== draggingNode.data.parentId) {
      //   let data = draggingNode.data;
      //   console.log("dropNode", dropNode)
      //   data.parentId = dropNode.data.parentId;
      //   this.$emit("edit", data)
      // } else {
      //   return null
      // }
    },
    /**
     * 执行删除是件
     */
    handleDelete(data) {
      this.$emit("delete", data)
    },
    /**
     * 获取父级信息
     */
    handleNodeParent(data, menu) {
      let node = this.$refs.tree.getNode(data);
      if (node.parent) {
        let data = {
          id: node.data.id,
          label: node.data.label
        };
        menu.push(data)
        this.handleNodeParent(node.parent, menu)
      }
      return menu
    },
    /**
     * 点击某一个节点
     * @param data
     */
    handleClick(data) {
      if (data.id === 0) {
        this.$refs.tree.setCurrentKey(null)
        this.$emit("breadcrumb", [])
      } else {
        let menu = [];
        let list = this.handleNodeParent(data, menu);
        this.$emit("breadcrumb", list.reverse());
      }
      this.$emit("input", data.id)
      this.$emit("change", data.id)
    },
    /**
     * 返回面包
     */
    handleBreadcrumb() {

    },
    handleEnter(n1, n2, e) {
      console.log("拖入", n1, n2, e)
    }
  }
};
</script>
<style lang="scss">
.category-node {
  .all {
    height: 40px;
    margin: 4px 0;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-left: 16px;

    &:hover {
      background-color: #F5F7FA;
    }
  }

  .all.category-active {
    background-color: #F5F7FA;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .category-tree {
    .el-tree-node__content {
      height: 40px;
      margin: 4px 0;
      border-radius: 6px;
    }
  }
}

</style>
